<template>
  <v-layout>
    <v-flex column wrap>
      <v-container fluid grid-list-lg>
        <v-layout class="wrap">
          <v-flex xs5 md5 lg5>
            <span class="caption">Delivery address</span>
            <v-card color="primary lighten-2">
              <v-card-title class="white--text">
                <div>
                  <div>
                    <strong>{{ shipTo.name1 }}</strong>
                  </div>
                  <div>{{ shipTo.name2 }}</div>
                  <div>{{ shipTo.name3 }}</div>
                  <div>{{ shipTo.street }} {{ shipTo.houseNumber }}</div>
                  <div>{{ shipTo.city }}</div>
                  <div>{{ shipTo.postalCode }}</div>
                  <div>{{ shipTo.country }}</div>
                </div>
              </v-card-title>
            </v-card>
          </v-flex>
          <v-flex>
            <span class="caption">Delivery options</span>
            <div>
              <v-chip label class="mx-0">{{ deliveryOptionText }}</v-chip>
            </div>
          </v-flex>
          <v-flex>
            <span class="caption">Order Type</span>
            <div>
              <v-chip label class="mx-0">{{ orderTypeText }}</v-chip>
            </div>
          </v-flex>
          <v-flex v-if="!!reqDeliveryDate">
            <span class="caption">Requested Delivery Date</span>
            <div>
              <v-chip label class="mx-0">
                <date-output :dateString="reqDeliveryDate" />
              </v-chip>
            </div>
          </v-flex>
          <v-flex v-if="!!customersOrderNo">
            <span class="caption">Your Order Number</span>
            <div>
              <v-chip label class="mx-0">{{ customersOrderNo }}</v-chip>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
      <hr />
      <v-container fluid grid-list-lg>
        <v-layout class="wrap">
          <v-flex v-if="endCustomer && endCustomer.name1" xs5 md5 lg5>
            <span class="caption">End customer address</span>
            <v-card color="primary lighten-2">
              <v-card-title class="white--text">
                <div>
                  <div>
                    <strong>{{ endCustomer.name1 }}</strong>
                  </div>
                  <div>{{ endCustomer.name2 }}</div>
                  <div>{{ endCustomer.name3 }}</div>
                  <div>
                    {{ endCustomer.street }} {{ endCustomer.houseNumber }}
                  </div>
                  <div>{{ endCustomer.city }}</div>
                  <div>{{ endCustomer.postalCode }}</div>
                  <div>{{ endCustomer.country }}</div>
                </div>
              </v-card-title>
            </v-card>
          </v-flex>
          <v-flex>
            <span class="caption">Application Field</span>
            <div>
              <v-chip label class="mx-0">{{ applicationFieldText }}</v-chip>
            </div>
          </v-flex>
          <v-flex v-if="isIndustryRequired && !!industry">
            <span class="caption">Industry</span>
            <div>
              <v-chip label class="mx-0">{{ industryText }}</v-chip>
            </div>
          </v-flex>
          <v-flex v-if="isIndustryRequired && !!vmApplication">
            <span class="caption">VM Application</span>
            <div>
              <v-chip label class="mx-0">{{ vmApplicationText }}</v-chip>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from "vuex";
import DateOutput from "@/components/DateOutput.vue";

export default {
  components: {
    DateOutput
  },
  computed: {
    ...mapState("basket", [
      "orderType",
      "deliveryOption",
      "applicationField",
      "reqDeliveryDate",
      "customersOrderNo",
      "shipTo",
      "endCustomer",
      "industry",
      "vmApplication"
    ]),
    deliveryOptionText() {
      return this.deliveryOption ? this.deliveryOption.text : "";
    },
    applicationFieldText() {
      return this.applicationField ? this.applicationField.text : "";
    },
    orderTypeText() {
      return this.orderType ? this.orderType.text : "";
    },
    industryText() {
      return this.industry ? this.industry.text : "";
    },
    vmApplicationText() {
      return this.vmApplication ? this.vmApplication.text : "";
    },
    isIndustryRequired() {
      return this.$store.getters["customer/isIndustryRequired"];
    }
  }
};
</script>
